module.exports = __webpack_public_path__ + "static/media/4C.e1dfc148.svg";